module.exports = __webpack_public_path__ + "static/media/topic.c13a1100.svg";